import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export interface ProductTypeFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

interface GetProductTypeListParams {
  filters: ProductTypeFilterParams;
  signal?: AbortSignal;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getProductTypeListAPI =
  ({ filters, onSuccess, onError, signal }: GetProductTypeListParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(
        "/static-data/product-component-type",
        {
          params: filters,
          signal,
        },
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
      console.error("Get Product Types List Error:", error);
      message.error(error?.response?.data?.message);
      onError?.();
    }
  };

interface UpdateProductTypeParams {
  payload: any; // Payload now includes 'id' inside it
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateProductTypeAPI =
  ({ payload, onSuccess, onError }: UpdateProductTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        "/static-data/product-component-type",
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Product Type updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update Product Type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Product Type error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to update Product Type";
      message.error(errorMessage);
    }
  };

interface CreateProductTypeParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const createProductTypeAPI =
  ({ payload, onSuccess, onError }: CreateProductTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(
        "/static-data/product-component-type",
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Create Product Type error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

interface DeleteProductTypeParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteProductTypeAPI =
  ({ id, onSuccess, onError }: DeleteProductTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete(
        "/static-data/product-component-type/permanent",
        {
          data: { id: id },
        },
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Product Type deleted successfully");
        onSuccess?.();
      } else {
        message.error(result?.message || "Failed to delete Product Type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Product Type error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to delete Product Type";
      message.error(errorMessage);
    }
  };

interface ReorderProductTypeParams {
  payload: any; // Payload now includes 'id' inside it
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const reorderProductTypeAPI =
  ({ payload, onSuccess, onError }: ReorderProductTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        "/static-data/product-component-type/reorder",
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Reorder error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };
